import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div 
                className="w-14 h-14 bg-cover bg-center rounded-2xl shadow-lg flex items-center justify-center relative overflow-hidden flex-shrink-0"
                style={{
                  backgroundImage: `url('https://public.readdy.ai/ai/img_res/6be61980acb5527e40900c8ac5917ab6.jpg')`
                }}
              >
                <div className="absolute inset-0 bg-gradient-to-br from-teal-500/95 to-blue-600/95"></div>
                <div className="relative text-center">
                  <div className="text-white font-bold text-2xl tracking-wider leading-none">ARM</div>
                </div>
              </div>
              <div className="flex flex-col">
                <div className="text-white font-bold text-sm leading-tight">Ali Residential Management LLC</div>
                <div className="text-gray-300 text-xs font-medium leading-tight mt-0.5">Your Home Away</div>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Professional residential management for short-term stays and future long-term rentals.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-teal-400">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/properties" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer">
                  Properties
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer">
                  Book Now
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4 text-teal-400">Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/short-term" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer">
                  Short-Term Rentals
                </Link>
              </li>
              <li>
                <Link to="/long-term" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer">
                  Long-Term Rentals
                </Link>
              </li>
              <li>
                <Link to="/landlords" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer">
                  For Landlords
                </Link>
              </li>
              <li>
                <Link to="/landlord-application" className="text-gray-400 hover:text-teal-400 transition-colors duration-300 cursor-pointer">
                  Landlord Application
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold text-white mb-4">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a href="tel:732-213-2063" className="text-teal-100 hover:text-white transition-colors cursor-pointer flex items-center space-x-2">
                  <i className="ri-phone-line"></i>
                  <span>732-213-2063</span>
                </a>
              </li>
              <li>
                <a href="mailto:Staying.arm@gmail.com" className="text-teal-100 hover:text-white transition-colors cursor-pointer flex items-center space-x-2">
                  <i className="ri-mail-line"></i>
                  <span>Staying.arm@gmail.com</span>
                </a>
              </li>
              <li className="text-teal-100 flex items-start space-x-2">
                <i className="ri-map-pin-line mt-1"></i>
                <span>Serving Pennsylvania</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {currentYear} Ali Residential Management. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-teal-400 transition-colors duration-300 text-sm cursor-pointer"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
